import React    from 'react';
import Settings from './CanvasSettings';
import Utils    from './Utils';
import _        from 'lodash';

const { interact } = window;

export default class MenuElement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.draggable = null;
    }

    componentDidMount() {
        interact(this.element).on('tap', (event) => {
            this.onClick();
        });

        this.resetDrag();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selected !== this.props.selected) {
            this.resetDrag();
        }
    }

    resetDrag() {

        this.draggable && this.draggable.unset();
        
        if (this.props.selected) {
            this.draggable = interact('.size-selector .size');
        } else {
            this.draggable = interact(this.element);
        }

        let clone = null;
        
        this.draggable.draggable({
            inertia:    true,
            autoScroll: true,
            onstart: (event) => {
                clone = document.createElement('img');
                clone.classList.add('drag-element');
                
                // Cuando se está seleccionando un tamaño, ahora el size viene en un attr
                if (event.target.getAttribute('data-size')) {
                    this.props.item.size = parseInt(event.target.getAttribute('data-size'), 10);
                }

                let size = this.props.item.size || Settings.defaultSize;
                const max = Settings.maxWidths[size - 1];
                clone.style.maxWidth  = max[0] + 'px';
                clone.style.maxHeight = max[1] + 'px';

                clone.src = 'img/element/' + this.props.item.src;

                let transform = 'translate(-50%,-50%)';
                // Buscamos la escala del canvas y se la aplicamos a esto
                // Apaño: Esto no es muy "Reacty" pero güeno
                const scale = Utils.scale(document.body.querySelector('.canvas'));
                if (scale !== 1) {
                    transform += ' scale(' + scale + ')';
                }

                clone.style.transform = transform;

                document.body.appendChild(clone);

                this.props.onElementDragStart(this.props.item, event);
            },
            onmove: (event) => {
                
                if (!this.props.draggedElement.canDrop) {
                    clone.classList.add('cant-drop');
                } else {
                    clone.classList.remove('cant-drop');
                }

                clone.style.top  = event.clientY + 'px';
                clone.style.left = event.clientX + 'px';
            },
            onend: (event) => {
                document.body.removeChild(clone);
                this.props.onElementDragEnd(this.props.item, event);
            }
        });
    }

    onClick() {
        const rect = this.element.getBoundingClientRect();
        this.props.item.top  = parseInt(rect.top, 10);
        this.props.item.left = parseInt(rect.left, 10);

        this.props.onClick(this.props.item);
    }

	render() {
        const item        = this.props.item;

        return <div className="item" ref={el => this.element = el }
            onClick={this.onClick.bind(this)}>
            <img src={'img/element/' + item.src.replace('/', '/thumb_')} width="30" role="presentation" draggable="false"/>

        </div>
	}
}



// WEBPACK FOOTER //
// ./src/MenuElement.js